import React, { useEffect, useState } from 'react'
import { useApp } from "./Appcontext";
import { Link, useOutletContext } from "react-router-dom";
function Rightmenu() {
         const { Rightmenut, setRightmenu } = useApp();
         const {user, token} = useOutletContext();
         const [friends, setFriends] = useState([]);
         const [group, setGroup] = useState([]);
            const getFriend = () => {
            fetch('/api/get-friend-list-home', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }).then((response) => response.json())
                .then((data) => {
                 
                    setFriends(data.data);
                }).catch((error) => {
                   
                });
        }

        useEffect(() => {
            getFriend();
        },[]);
  return (
    <div>
         <div className={Rightmenut ? "right-chat nav-wrap mt-2 right-scroll-bar active-sidebar" : "right-chat nav-wrap mt-2 right-scroll-bar "} style={{zIndex: '9'}}>
            <div className="middle-sidebar-right-content bg-white shadow-xss rounded-xxl">

                
                <div className="preloader-wrap p-3">
                    <div className="box shimmer">
                        <div className="lines">
                            <div className="line s_shimmer"></div>
                            <div className="line s_shimmer"></div>
                            <div className="line s_shimmer"></div>
                            <div className="line s_shimmer"></div>
                        </div>
                    </div>
                    <div className="box shimmer mb-3">
                        <div className="lines">
                            <div className="line s_shimmer"></div>
                            <div className="line s_shimmer"></div>
                            <div className="line s_shimmer"></div>
                            <div className="line s_shimmer"></div>
                        </div>
                    </div>
                    <div className="box shimmer">
                        <div className="lines">
                            <div className="line s_shimmer"></div>
                            <div className="line s_shimmer"></div>
                            <div className="line s_shimmer"></div>
                            <div className="line s_shimmer"></div>
                        </div>
                    </div>
                </div>
               
                <div className="section full pe-3 ps-4 pt-4 position-relative feed-body my-4">
                    <h4 className="font-xsssss text-grey-500 text-uppercase fw-700 ls-3">Connections</h4>
                    <ul className="list-group list-group-flush">
                        {friends.length > 0 && friends.map((friend) => (
                            <li  key={friend.id} className="bg-transparent list-group-item no-icon pe-0 ps-0 pt-2 pb-2 border-0 d-flex align-items-center mb-2">
                                <figure className="avatar float-left mb-0 me-2">
                                    <Link to={`/profile/${friend.id}`}>
                                    <img src={friend.profile_picture} alt="image"  className="w35 border-radius rounded-circle" />
                                    </Link>
                                </figure>
                                <h3 className="fw-700 mb-0 mt-0">
                                    <Link to={`/profile/${friend.id}`} className="font-xssss text-grey-600 d-block text-dark model-popup-chat">
                                   {friend.name}
                                    </Link>
                                </h3>
                            </li>
                        ))}
                        {friends.length == 0 && (
                            <li key={1}  className="bg-transparent list-group-item no-icon pe-0 ps-0 pt-2 pb-2 border-0 d-flex align-items-center mb-2">
                                <h3 className="font-xssss text-grey-600 d-block text-dark model-popup-chat">
                                  
                                   No Friend to show
                                  
                                </h3>
                            </li>
                        )}
                        
                    </ul>
                    <h4 className="font-xsssss text-grey-500 text-uppercase fw-700 ls-3">Groups</h4>
                    <ul className="list-group list-group-flush">
                        {group.length > 0 && group.map((gp) => (
                            <li className="bg-transparent list-group-item no-icon pe-0 ps-0 pt-2 pb-2 border-0 d-flex align-items-center mb-2">
                                <figure className="avatar float-left mb-0 me-2">
                                    <Link to={`/profile/${gp.id}`}>
                                    <img src={gp.profile_picture} alt="image"  className="w35 border-radius rounded-circle" />
                                    </Link>
                                </figure>
                                <h3 className="fw-700 mb-0 mt-0">
                                    <Link to={`/profile/${gp.id}`} className="font-xssss text-grey-600 d-block text-dark model-popup-chat">
                                   {gp.name}
                                    </Link>
                                </h3>
                            </li>
                        ))}


                        {group.length == 0 && (
                            <li className="bg-transparent list-group-item no-icon pe-0 ps-0 pt-2 pb-2 border-0 d-flex align-items-center mb-2">
                                <h3 className="font-xssss text-grey-600 d-block text-dark model-popup-chat">
                                  
                                   No Group to show
                                  
                                </h3>
                            </li>
                        )}

                        
                    </ul>
                </div>
          
               
            </div>
        </div>
    </div>
  )
}

export default Rightmenu